import { ScheduledCommunicationTypesQueries } from '@/graphql/queries/scheduledCommunicationTypes.queries'
import { ScheduledCommunicationType } from '@/types/ScheduledCommunicationType'

import { useGraphql } from '../useGraphql'

const useScheduledCommunicationType = (scheduledCommunicationTypeId: number) => {
  return useGraphql<{ scheduledCommunicationType: ScheduledCommunicationType }>(
    ScheduledCommunicationTypesQueries.QUERY_KEYS.getScheduledCommunicationType,
    ScheduledCommunicationTypesQueries.getScheduledCommunicationType(),
    { id: scheduledCommunicationTypeId },
    { enabled: true, refetchOnMount: 'always' },
  )
}

export default useScheduledCommunicationType
